(function () {
  'use strict';

  var config = window.HENGE_LP_ANALYTICS_CONFIG || {};
  var endpoint = typeof config.endpoint === 'string' ? config.endpoint.trim() : '';
  var eventVersion = config.eventVersion || '1.0.0';
  var allowedPaths = ['/pages/clearlp', '/pages/henge-clear', '/pages/clearlottery', '/pages/thanks'];
  var path = normalizePath(window.location.pathname);

  if (allowedPaths.indexOf(path) === -1) return;

  var KEYS = {
    visitorId: 'henge_lp_visitor_id_v1',
    sessionId: 'henge_lp_session_id_v1',
    campaign: 'henge_lp_campaign_v1',
    lpVariant: 'henge_lp_variant_v1',
    journeyId: 'henge_lp_journey_id_v1',
    journeyState: 'henge_lp_journey_state_v1',
    applicationBridge: 'henge_lp_application_bridge_v1',
    applicationPending: 'henge_lp_application_pending_v1',
    applicationComplete: 'henge_lp_application_complete_v1',
    completionQueue: 'henge_lp_completion_queue_v1',
    completionDone: 'henge_lp_completion_done_v1',
    sessionTotals: 'henge_lp_session_totals_v1',
    sessionStateV2: 'henge_lp_session_state_v2',
    pendingSnapshotV2: 'henge_lp_pending_snapshot_v2',
    pendingCompletionSnapshotV2: 'henge_lp_pending_completion_snapshot_v2'
  };
  var LEGACY_UTM_KEYS = {
    utm_source: 'henge_clarity_utm_source',
    utm_medium: 'henge_clarity_utm_medium',
    utm_campaign: 'henge_clarity_utm_campaign',
    utm_content: 'henge_clarity_utm_content'
  };
  var ENGAGEMENT_THRESHOLDS = [10, 30, 60];
  var SCROLL_THRESHOLDS = [25, 50, 75, 90, 100];
  var SECTION_VIEW_DELAY_MS = 1000;
  var SECTION_MIN_SECONDS = 1;
  var BATCH_SIZE = 10;
  var FLUSH_INTERVAL_MS = 4000;
  var SNAPSHOT_INTERVAL_MS = 15000;
  var JOURNEY_TIMEOUT_MS = 30 * 60 * 1000;
  var APPLICATION_BRIDGE_TTL_MS = 2 * 60 * 60 * 1000;
  var COMPLETION_DEDUPE_TTL_MS = 48 * 60 * 60 * 1000;
  var IDENTITY_TOUCH_INTERVAL_MS = 30000;

  var applicationBridge = readApplicationBridge();
  var visitorId = getOrCreateId('local', KEYS.visitorId, 'hv_');
  var sessionId = getOrRestoreSessionId(applicationBridge);
  var journeyId = getOrCreateJourneyId(applicationBridge);
  var pageviewId = createId('hp_');
  var campaign = getFirstTouchCampaign();
  var lpVariant = getLpVariant();
  var queue = [];
  var sentOnce = {};
  var occurrences = {};
  var sectionStates = [];
  var formStates = [];
  var pageStartedAt = Date.now();
  var activeStartedAt = isPageActive() ? performance.now() : 0;
  var activeElapsedMs = 0;
  var maxScrollDepth = 0;
  var scrollTicking = false;
  var finalSummarySent = false;
  var flushTimer = null;
  var snapshotTimer = null;
  var sessionState = restoreSessionStateV2();
  var sessionStateDirty = false;
  var lastIdentityTouchAt = 0;

  function normalizePath(value) {
    var normalized = String(value || '/').replace(/\/+$/, '');
    return normalized || '/';
  }

  function storageGet(scope, key) {
    try {
      return (scope === 'local' ? window.localStorage : window.sessionStorage).getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(scope, key, value) {
    try {
      (scope === 'local' ? window.localStorage : window.sessionStorage).setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function storageRemove(scope, key) {
    try {
      (scope === 'local' ? window.localStorage : window.sessionStorage).removeItem(key);
    } catch (error) {}
  }

  function parseJson(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function randomUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }

    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (byte) {
      return ('0' + byte.toString(16)).slice(-2);
    }).join('');

    return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-');
  }

  function createId(prefix) {
    return prefix + randomUuid();
  }

  function getOrCreateId(scope, key, prefix) {
    var stored = storageGet(scope, key);
    if (stored && stored.indexOf(prefix) === 0) return stored;
    var created = createId(prefix);
    storageSet(scope, key, created);
    return created;
  }

  function validAnonymousId(value, prefix) {
    return typeof value === 'string' && new RegExp('^' + prefix + '[A-Za-z0-9-]+$').test(value) && value.length <= 80;
  }

  function readApplicationBridge() {
    var bridge = parseJson(storageGet('local', KEYS.applicationBridge), null);
    if (!bridge || Number(bridge.expires_at || 0) <= Date.now()) {
      storageRemove('local', KEYS.applicationBridge);
      return null;
    }
    return bridge;
  }

  function getOrRestoreSessionId(bridge) {
    var stored = storageGet('session', KEYS.sessionId);
    if (validAnonymousId(stored, 'hs_')) return stored;
    if (bridge && validAnonymousId(bridge.session_id, 'hs_')) {
      storageSet('session', KEYS.sessionId, bridge.session_id);
      return bridge.session_id;
    }
    return getOrCreateId('session', KEYS.sessionId, 'hs_');
  }

  function getOrCreateJourneyId(bridge) {
    var now = Date.now();
    var sessionJourney = storageGet('session', KEYS.journeyId);
    var localState = parseJson(storageGet('local', KEYS.journeyState), null);
    var candidate = bridge && validAnonymousId(bridge.journey_id, 'hj_') ? bridge.journey_id : sessionJourney;
    if (!validAnonymousId(candidate, 'hj_') && localState && Number(localState.expires_at || 0) > now) {
      candidate = localState.journey_id;
    }
    if (!validAnonymousId(candidate, 'hj_') || (localState && Number(localState.expires_at || 0) <= now && !(bridge && bridge.journey_id === candidate))) {
      candidate = createId('hj_');
    }
    storageSet('session', KEYS.journeyId, candidate);
    storageSet('local', KEYS.journeyState, JSON.stringify({ journey_id: candidate, last_activity_at: now, expires_at: now + JOURNEY_TIMEOUT_MS }));
    return candidate;
  }

  function touchJourneyIdentity(force) {
    var now = Date.now();
    if (!force && now - lastIdentityTouchAt < IDENTITY_TOUCH_INTERVAL_MS) return;
    var state = parseJson(storageGet('local', KEYS.journeyState), null);
    if (!state || state.journey_id !== journeyId || Number(state.expires_at || 0) <= now) {
      journeyId = createId('hj_');
      storageSet('session', KEYS.journeyId, journeyId);
      setClarityIdentityTags();
    }
    storageSet('local', KEYS.journeyState, JSON.stringify({ journey_id: journeyId, last_activity_at: now, expires_at: now + JOURNEY_TIMEOUT_MS }));
    lastIdentityTouchAt = now;
  }

  function cleanCampaignValue(value) {
    var cleaned = String(value || '').replace(/[<>\u0000-\u001f\u007f]/g, '').trim();
    return cleaned.slice(0, 180);
  }

  function getFirstTouchCampaign() {
    var stored = parseJson(storageGet('session', KEYS.campaign), null);
    if (stored) return stored;

    var params;
    try {
      params = new URLSearchParams(window.location.search || '');
    } catch (error) {
      params = { get: function () { return ''; } };
    }

    var result = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (name) {
      var legacy = storageGet('session', LEGACY_UTM_KEYS[name]);
      if (legacy === 'unknown') legacy = '';
      result[name] = cleanCampaignValue(legacy || params.get(name) || '');
      if (!legacy && result[name]) storageSet('session', LEGACY_UTM_KEYS[name], result[name]);
    });
    result.utm_term = cleanCampaignValue(params.get('utm_term') || '');
    result.fbclid = cleanCampaignValue(params.get('fbclid') || '');
    storageSet('session', KEYS.campaign, JSON.stringify(result));
    return result;
  }

  function getLpVariant() {
    var variant = '';
    if (path === '/pages/clearlp') variant = 'clearlp';
    if (path === '/pages/henge-clear') variant = 'henge-clear';
    if (path === '/pages/clearlottery') variant = 'clearlottery';

    if (variant) {
      storageSet('session', KEYS.lpVariant, variant);
      return variant;
    }

    return storageGet('session', KEYS.lpVariant) || (applicationBridge && applicationBridge.lp_variant) || 'unknown';
  }

  function setClarityIdentityTags(attempt) {
    attempt = Number(attempt || 0);
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'henge_session_id', sessionId);
        window.clarity('set', 'henge_journey_id', journeyId);
        window.clarity('set', 'henge_lp_variant', lpVariant);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (key) {
          if (campaign[key]) window.clarity('set', key, campaign[key]);
        });
        return;
      }
    } catch (error) {
      return;
    }
    if (attempt < 20) {
      window.setTimeout(function () { setClarityIdentityTags(attempt + 1); }, 500);
    }
  }

  function sanitizeUrl(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      return parsed.origin + normalizePath(parsed.pathname);
    } catch (error) {
      return '';
    }
  }

  function detectDeviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width <= 767) return 'mobile';
    if (width <= 1024) return 'tablet';
    return 'desktop';
  }

  function detectBrowser() {
    var ua = navigator.userAgent || '';
    if (/Edg\//.test(ua)) return 'Edge';
    if (/OPR\//.test(ua)) return 'Opera';
    if (/CriOS\//.test(ua)) return 'Chrome iOS';
    if (/FxiOS\//.test(ua)) return 'Firefox iOS';
    if (/Chrome\//.test(ua)) return 'Chrome';
    if (/Firefox\//.test(ua)) return 'Firefox';
    if (/Safari\//.test(ua) && /Version\//.test(ua)) return 'Safari';
    return 'Other';
  }

  function detectOs() {
    var ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
    if (/Android/.test(ua)) return 'Android';
    if (/Windows/.test(ua)) return 'Windows';
    if (/Mac OS X/.test(ua)) return 'macOS';
    if (/Linux/.test(ua)) return 'Linux';
    return 'Other';
  }

  function isPageActive() {
    return document.visibilityState !== 'hidden';
  }

  function pauseActiveClock() {
    if (!activeStartedAt) return;
    activeElapsedMs += Math.max(0, performance.now() - activeStartedAt);
    activeStartedAt = 0;
  }

  function resumeActiveClock() {
    if (!activeStartedAt && isPageActive()) activeStartedAt = performance.now();
  }

  function getActiveSeconds() {
    var elapsed = activeElapsedMs;
    if (activeStartedAt) elapsed += Math.max(0, performance.now() - activeStartedAt);
    return Math.max(0, Math.round(elapsed / 100) / 10);
  }

  function getTotalSeconds() {
    return Math.max(0, Math.round((Date.now() - pageStartedAt) / 100) / 10);
  }

  function getScrollDepth() {
    var doc = document.documentElement;
    var body = document.body;
    var top = window.pageYOffset || doc.scrollTop || 0;
    var height = Math.max(doc.scrollHeight, doc.offsetHeight, body ? body.scrollHeight : 0, body ? body.offsetHeight : 0);
    var viewport = window.innerHeight || doc.clientHeight || 1;
    var available = height - viewport;
    if (available <= 0) return 100;
    return Math.min(100, Math.max(0, Math.round((top / available) * 100)));
  }

  function nextOccurrence(name) {
    occurrences[name] = (occurrences[name] || 0) + 1;
    return occurrences[name];
  }

  function buildDuplicateKey(eventName, details, occurrence) {
    return [
      sessionId,
      pageviewId,
      eventName,
      details.section_id || '',
      details.faq_id || '',
      details.form_id || '',
      details.completion_id || '',
      details.event_value || '',
      occurrence || 1
    ].join('|').slice(0, 500);
  }

  function buildEvent(eventName, details, occurrence) {
    details = details || {};
    return {
      event_id: createId('he_'),
      event_timestamp: new Date().toISOString(),
      visitor_id: visitorId,
      session_id: sessionId,
      journey_id: journeyId,
      pageview_id: pageviewId,
      event_name: eventName,
      event_value: String(details.event_value || '').slice(0, 180),
      page_path: path,
      page_url: sanitizeUrl(window.location.href),
      lp_variant: lpVariant,
      referrer: sanitizeUrl(document.referrer),
      utm_source: campaign.utm_source || '',
      utm_medium: campaign.utm_medium || '',
      utm_campaign: campaign.utm_campaign || '',
      utm_content: campaign.utm_content || '',
      utm_term: campaign.utm_term || '',
      fbclid: campaign.fbclid || '',
      device_type: detectDeviceType(),
      browser: detectBrowser(),
      os: detectOs(),
      screen_width: Number(window.screen && window.screen.width) || 0,
      screen_height: Number(window.screen && window.screen.height) || 0,
      scroll_depth: Number(details.scroll_depth === undefined ? maxScrollDepth : details.scroll_depth) || 0,
      active_seconds: Number(details.active_seconds === undefined ? getActiveSeconds() : details.active_seconds) || 0,
      total_seconds: Number(details.total_seconds === undefined ? getTotalSeconds() : details.total_seconds) || 0,
      section_id: String(details.section_id || '').slice(0, 100),
      section_seconds: Number(details.section_seconds) || 0,
      faq_id: String(details.faq_id || '').slice(0, 100),
      form_id: String(details.form_id || '').slice(0, 120),
      form_placement: String(details.form_placement || '').slice(0, 20),
      completion_id: String(details.completion_id || '').slice(0, 80),
      event_version: eventVersion,
      duplicate_key: buildDuplicateKey(eventName, details, occurrence)
    };
  }

  function track(eventName, details, options) {
    options = options || {};
    var onceKey = options.onceKey || eventName;
    if (options.once && sentOnce[onceKey]) return;
    if (options.once) sentOnce[onceKey] = true;

    var occurrence = options.once ? 1 : nextOccurrence(onceKey);
    var event = buildEvent(eventName, details, occurrence);
    queue.push(event);
    recordSessionEventV2(event);
    if (eventName === 'application_complete') persistCompletionEvent(event);

    if (eventName === 'page_view') sendSessionSnapshotV2('page_view', false, false);
    if (eventName === 'form_start' || eventName === 'form_error' || eventName === 'form_submit') {
      sendSessionSnapshotV2(eventName, false, false);
    }
    if (eventName === 'application_complete') sendSessionSnapshotV2('application_complete', false, true);
    if (options.immediate || queue.length >= BATCH_SIZE) flushQueue(false);
    return event;
  }

  function completionIdsFromBatch(batch) {
    return batch.filter(function (event) {
      return event.event_name === 'application_complete' && event.completion_id;
    }).map(function (event) { return event.completion_id; });
  }

  function markCompletionDelivered(ids) {
    if (!ids.length) return;
    var now = Date.now();
    var done = parseJson(storageGet('local', KEYS.completionDone), {});
    ids.forEach(function (id) { done[id] = now + COMPLETION_DEDUPE_TTL_MS; });
    Object.keys(done).forEach(function (id) { if (Number(done[id]) <= now) delete done[id]; });
    storageSet('local', KEYS.completionDone, JSON.stringify(done));
    var pending = parseJson(storageGet('local', KEYS.completionQueue), []);
    storageSet('local', KEYS.completionQueue, JSON.stringify(pending.filter(function (event) {
      return ids.indexOf(event.completion_id) === -1;
    })));
  }

  function flushQueue(useBeacon) {
    if (!queue.length || !endpoint) return;
    var batch = queue.splice(0, queue.length);
    var body = JSON.stringify({ events: batch });
    var completionIds = completionIdsFromBatch(batch);

    try {
      if (useBeacon && navigator.sendBeacon) {
        var accepted = navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        if (accepted) {
          markCompletionDelivered(completionIds);
          return;
        }
      }

      window.fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        keepalive: Boolean(useBeacon),
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body
      }).then(function () {
        markCompletionDelivered(completionIds);
      }).catch(function () {
        batch.forEach(function (event) {
          if (event.event_name === 'application_complete') persistCompletionEvent(event);
        });
      });
    } catch (error) {}
  }

  function createSessionStateV2() {
    var now = new Date().toISOString();
    return {
      visitor_id: visitorId,
      session_id: sessionId,
      journey_id: journeyId,
      revision: 0,
      sequence: 0,
      session_start: now,
      session_end: now,
      updated_at: now,
      snapshot_status: 'active',
      is_finalized: false,
      lp_variant: lpVariant,
      referrer: sanitizeUrl(document.referrer),
      campaign: campaign,
      device: {
        device_type: detectDeviceType(),
        browser: detectBrowser(),
        os: detectOs(),
        screen_width: Number(window.screen && window.screen.width) || 0,
        screen_height: Number(window.screen && window.screen.height) || 0
      },
      pageviews: {},
      sections: {},
      faqs: {},
      forms: {},
      scroll_milestones: {},
      engagement_milestones: {},
      event_type_counts: {},
      events: [],
      max_scroll_depth: 0,
      total_seconds: 0,
      active_seconds: 0,
      hidden_seconds: 0,
      is_applicant: false,
      application_timestamp: '',
      snapshot_send_count: 0,
      total_payload_bytes: 0,
      last_payload_size_bytes: 0,
      average_payload_size_bytes: 0
    };
  }

  function restoreSessionStateV2() {
    var stored = parseJson(storageGet('session', KEYS.sessionStateV2), null);
    if (!stored || stored.session_id !== sessionId || stored.visitor_id !== visitorId) {
      return createSessionStateV2();
    }

    stored.pageviews = stored.pageviews || {};
    stored.sections = stored.sections || {};
    stored.faqs = stored.faqs || {};
    stored.forms = stored.forms || {};
    stored.scroll_milestones = stored.scroll_milestones || {};
    stored.engagement_milestones = stored.engagement_milestones || {};
    stored.event_type_counts = stored.event_type_counts || {};
    stored.events = Array.isArray(stored.events) ? stored.events : [];
    stored.campaign = stored.campaign || campaign;
    stored.device = stored.device || {};
    stored.lp_variant = stored.lp_variant === 'unknown' && lpVariant !== 'unknown' ? lpVariant : (stored.lp_variant || lpVariant);
    stored.journey_id = journeyId;
    return stored;
  }

  function persistSessionStateV2() {
    sessionState.updated_at = new Date().toISOString();
    storageSet('session', KEYS.sessionStateV2, JSON.stringify(sessionState));
  }

  function ensureCurrentPageviewV2(timestamp) {
    if (!sessionState.pageviews[pageviewId]) {
      sessionState.pageviews[pageviewId] = {
        page_path: path,
        started_at: timestamp || new Date().toISOString(),
        ended_at: timestamp || new Date().toISOString(),
        total_seconds: 0,
        active_seconds: 0,
        max_scroll_depth: 0
      };
    }
    return sessionState.pageviews[pageviewId];
  }

  function sumPageviewMetricV2(metric) {
    return Object.keys(sessionState.pageviews).reduce(function (sum, id) {
      return sum + Number(sessionState.pageviews[id][metric] || 0);
    }, 0);
  }

  function syncSessionMetricsV2() {
    var now = new Date().toISOString();
    var pageview = ensureCurrentPageviewV2(now);
    pageview.ended_at = now;
    pageview.total_seconds = Math.max(Number(pageview.total_seconds || 0), getTotalSeconds());
    pageview.active_seconds = Math.max(Number(pageview.active_seconds || 0), getActiveSeconds());
    pageview.max_scroll_depth = Math.max(Number(pageview.max_scroll_depth || 0), maxScrollDepth);

    sessionState.session_end = now;
    sessionState.max_scroll_depth = Math.max(Number(sessionState.max_scroll_depth || 0), maxScrollDepth);
    sessionState.total_seconds = Math.round(sumPageviewMetricV2('total_seconds') * 10) / 10;
    sessionState.active_seconds = Math.round(sumPageviewMetricV2('active_seconds') * 10) / 10;
    sessionState.hidden_seconds = Math.max(0, Math.round((sessionState.total_seconds - sessionState.active_seconds) * 10) / 10);
  }

  function recordSessionEventV2(event) {
    var timestamp = event.event_timestamp;
    var pageview = ensureCurrentPageviewV2(timestamp);
    pageview.ended_at = timestamp;
    pageview.total_seconds = Math.max(Number(pageview.total_seconds || 0), Number(event.total_seconds || 0));
    pageview.active_seconds = Math.max(Number(pageview.active_seconds || 0), Number(event.active_seconds || 0));
    pageview.max_scroll_depth = Math.max(Number(pageview.max_scroll_depth || 0), Number(event.scroll_depth || 0));

    var compactEvent = {
      event_id: event.event_id,
      event_timestamp: timestamp,
      event_name: event.event_name,
      event_value: event.event_value || '',
      pageview_id: event.pageview_id,
      page_path: event.page_path,
      scroll_depth: Number(event.scroll_depth || 0),
      section_id: event.section_id || '',
      section_seconds: Number(event.section_seconds || 0),
      faq_id: event.faq_id || '',
      form_id: event.form_id || '',
      form_placement: event.form_placement || '',
      journey_id: event.journey_id || '',
      completion_id: event.completion_id || ''
    };
    sessionState.events.push(compactEvent);
    sessionState.event_type_counts[event.event_name] = Number(sessionState.event_type_counts[event.event_name] || 0) + 1;

    if (event.event_name.indexOf('engaged_') === 0) sessionState.engagement_milestones[event.event_name] = true;
    if (event.event_name.indexOf('scroll_') === 0) {
      sessionState.scroll_milestones[event.event_name.replace('scroll_', '')] = true;
    }

    if (event.event_name === 'section_view' && event.section_id) {
      var section = sessionState.sections[event.section_id] || {
        viewed: false,
        view_count: 0,
        total_seconds: 0,
        first_view_at: '',
        last_leave_at: ''
      };
      section.viewed = true;
      section.view_count += 1;
      if (!section.first_view_at) section.first_view_at = timestamp;
      sessionState.sections[event.section_id] = section;
    }
    if (event.event_name === 'section_leave' && event.section_id) {
      var leavingSection = sessionState.sections[event.section_id] || {
        viewed: true,
        view_count: 0,
        total_seconds: 0,
        first_view_at: '',
        last_leave_at: ''
      };
      leavingSection.viewed = true;
      leavingSection.total_seconds = Math.round((Number(leavingSection.total_seconds || 0) + Number(event.section_seconds || 0)) * 10) / 10;
      leavingSection.last_leave_at = timestamp;
      sessionState.sections[event.section_id] = leavingSection;
    }

    if ((event.event_name === 'faq_open' || event.event_name === 'faq_close') && event.faq_id) {
      var faq = sessionState.faqs[event.faq_id] || { open_count: 0, close_count: 0, first_open_at: '', last_close_at: '' };
      if (event.event_name === 'faq_open') {
        faq.open_count += 1;
        if (!faq.first_open_at) faq.first_open_at = timestamp;
      } else {
        faq.close_count += 1;
        faq.last_close_at = timestamp;
      }
      sessionState.faqs[event.faq_id] = faq;
    }

    if (event.event_name.indexOf('form_') === 0 && event.form_id) {
      var form = sessionState.forms[event.form_id] || {
        form_id: event.form_id,
        section_id: event.section_id || '',
        form_placement: event.form_placement || '',
        viewed: false,
        view_count: 0,
        started: false,
        start_count: 0,
        error_count: 0,
        submitted: false,
        submit_count: 0,
        first_view_at: '',
        first_start_at: '',
        submitted_at: ''
      };
      form.section_id = form.section_id || event.section_id || '';
      form.form_placement = form.form_placement || event.form_placement || '';
      if (event.event_name === 'form_view') {
        form.viewed = true;
        form.view_count += 1;
        if (!form.first_view_at) form.first_view_at = timestamp;
      }
      if (event.event_name === 'form_start') {
        form.started = true;
        form.start_count += 1;
        if (!form.first_start_at) form.first_start_at = timestamp;
      }
      if (event.event_name === 'form_error') form.error_count += 1;
      if (event.event_name === 'form_submit') {
        form.submitted = true;
        form.submit_count += 1;
        form.submitted_at = timestamp;
      }
      sessionState.forms[event.form_id] = form;
    }

    if (event.event_name === 'application_complete') {
      sessionState.is_applicant = true;
      sessionState.application_timestamp = sessionState.application_timestamp || timestamp;
      sessionState.is_finalized = true;
      sessionState.snapshot_status = 'application_complete';
    }

    sessionState.max_scroll_depth = Math.max(Number(sessionState.max_scroll_depth || 0), Number(event.scroll_depth || 0));
    sessionState.session_end = timestamp;
    sessionState.updated_at = timestamp;
    sessionStateDirty = true;
    syncSessionMetricsV2();
    persistSessionStateV2();
  }

  function snapshotStatusV2(reason, isFinal) {
    if (reason === 'application_complete' || sessionState.is_applicant) return 'application_complete';
    if (reason === 'visibility_hidden' || reason === 'pagehide') return 'hidden';
    if (isFinal) return 'completed';
    return 'active';
  }

  function byteLengthV2(value) {
    try {
      if (window.TextEncoder) return new window.TextEncoder().encode(value).length;
      return new Blob([value]).size;
    } catch (error) {
      return unescape(encodeURIComponent(value)).length;
    }
  }

  function buildSessionSnapshotV2(reason, isFinal) {
    syncSessionMetricsV2();
    sessionState.revision = Number(sessionState.revision || 0) + 1;
    sessionState.sequence = Number(sessionState.sequence || 0) + 1;
    sessionState.snapshot_status = snapshotStatusV2(reason, isFinal);
    sessionState.is_finalized = Boolean(sessionState.is_finalized || isFinal);
    sessionState.snapshot_send_count = Number(sessionState.snapshot_send_count || 0) + 1;
    sessionState.updated_at = new Date().toISOString();

    var payload = {
      type: 'session_snapshot',
      session_id: sessionId,
      visitor_id: visitorId,
      journey_id: journeyId,
      revision: sessionState.revision,
      sequence: sessionState.sequence,
      snapshot_created_at: sessionState.updated_at,
      snapshot_reason: reason,
      snapshot_status: sessionState.snapshot_status,
      is_final: Boolean(isFinal),
      event_version: eventVersion,
      session: {
        session_start: sessionState.session_start,
        session_end: sessionState.session_end,
        journey_id: journeyId,
        lp_variant: sessionState.lp_variant,
        referrer: sessionState.referrer,
        campaign: sessionState.campaign,
        device: sessionState.device,
        pageviews: sessionState.pageviews,
        sections: sessionState.sections,
        faqs: sessionState.faqs,
        forms: sessionState.forms,
        scroll_milestones: sessionState.scroll_milestones,
        engagement_milestones: sessionState.engagement_milestones,
        event_type_counts: sessionState.event_type_counts,
        events: sessionState.events,
        max_scroll_depth: sessionState.max_scroll_depth,
        total_seconds: sessionState.total_seconds,
        active_seconds: sessionState.active_seconds,
        hidden_seconds: sessionState.hidden_seconds,
        is_applicant: sessionState.is_applicant,
        application_timestamp: sessionState.application_timestamp,
        snapshot_send_count: sessionState.snapshot_send_count,
        total_payload_bytes: sessionState.total_payload_bytes,
        average_payload_size_bytes: sessionState.average_payload_size_bytes
      }
    };

    var body = JSON.stringify(payload);
    var size = byteLengthV2(body);
    sessionState.last_payload_size_bytes = size;
    sessionState.total_payload_bytes = Number(sessionState.total_payload_bytes || 0) + size;
    sessionState.average_payload_size_bytes = Math.round(sessionState.total_payload_bytes / sessionState.snapshot_send_count);
    payload.session.payload_size_bytes = size;
    payload.session.total_payload_bytes = sessionState.total_payload_bytes;
    payload.session.average_payload_size_bytes = sessionState.average_payload_size_bytes;
    body = JSON.stringify(payload);

    persistSessionStateV2();
    storageSet('session', KEYS.pendingSnapshotV2, JSON.stringify({ revision: payload.revision, body: body }));
    if (sessionState.is_applicant) {
      storageSet('local', KEYS.pendingCompletionSnapshotV2, JSON.stringify({ revision: payload.revision, body: body }));
    }
    sessionStateDirty = false;
    return { payload: payload, body: body, size: byteLengthV2(body) };
  }

  function clearPendingSnapshotV2(revision) {
    var pending = parseJson(storageGet('session', KEYS.pendingSnapshotV2), null);
    if (pending && Number(pending.revision) === Number(revision)) storageRemove('session', KEYS.pendingSnapshotV2);
    var completionPending = parseJson(storageGet('local', KEYS.pendingCompletionSnapshotV2), null);
    if (completionPending && Number(completionPending.revision) === Number(revision)) {
      storageRemove('local', KEYS.pendingCompletionSnapshotV2);
    }
  }

  function transmitSessionSnapshotV2(snapshot, useBeacon) {
    if (!endpoint || !snapshot || !snapshot.body) return false;
    try {
      if (useBeacon && navigator.sendBeacon) {
        var accepted = navigator.sendBeacon(endpoint, new Blob([snapshot.body], { type: 'text/plain;charset=UTF-8' }));
        if (accepted) {
          clearPendingSnapshotV2(snapshot.payload ? snapshot.payload.revision : snapshot.revision);
          return true;
        }
      }
      window.fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        keepalive: Boolean(useBeacon),
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: snapshot.body
      }).then(function () {
        clearPendingSnapshotV2(snapshot.payload ? snapshot.payload.revision : snapshot.revision);
      }).catch(function () {
        sessionStateDirty = true;
      });
      return true;
    } catch (error) {
      return false;
    }
  }

  function sendSessionSnapshotV2(reason, useBeacon, isFinal) {
    if (!endpoint) return null;
    if (reason === 'interval' && !sessionStateDirty) return null;
    var snapshot = buildSessionSnapshotV2(reason, Boolean(isFinal));
    transmitSessionSnapshotV2(snapshot, Boolean(useBeacon));
    return snapshot.payload;
  }

  function resendPendingSnapshotV2() {
    if (!endpoint) return;
    var pending = parseJson(storageGet('session', KEYS.pendingSnapshotV2), null);
    if (pending && pending.body) transmitSessionSnapshotV2({ body: pending.body, revision: pending.revision }, false);
    var completionPending = parseJson(storageGet('local', KEYS.pendingCompletionSnapshotV2), null);
    if (completionPending && completionPending.body && (!pending || completionPending.revision !== pending.revision)) {
      transmitSessionSnapshotV2({ body: completionPending.body, revision: completionPending.revision }, false);
    }
  }

  function updateScroll() {
    scrollTicking = false;
    maxScrollDepth = Math.max(maxScrollDepth, getScrollDepth());
    SCROLL_THRESHOLDS.forEach(function (threshold) {
      if (maxScrollDepth >= threshold) {
        track('scroll_' + threshold, { scroll_depth: threshold }, { once: true });
      }
    });
  }

  function initScrollTracking() {
    var onScroll = function (event) {
      if (event && event.isTrusted) touchJourneyIdentity(false);
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateScroll();
  }

  function initEngagementTracking() {
    window.setInterval(function () {
      var active = getActiveSeconds();
      ENGAGEMENT_THRESHOLDS.forEach(function (seconds) {
        if (active >= seconds) track('engaged_' + seconds + 's', {}, { once: true });
      });
    }, 1000);
  }

  function isRenderedElement(element) {
    if (!element || element.hidden || !element.getClientRects().length) return false;
    var style = window.getComputedStyle ? window.getComputedStyle(element) : null;
    return !style || (style.display !== 'none' && style.visibility !== 'hidden');
  }

  function isTrackableSectionElement(element) {
    if (!isRenderedElement(element)) return false;
    var tagged = element.querySelector('[data-henge-canonical-id], [data-henge-analytics-section]');
    return !tagged || isRenderedElement(tagged);
  }

  function sectionBaseId(element, fallbackIndex) {
    var tagged = element.querySelector('[data-henge-canonical-id], [data-henge-analytics-section]');
    var canonical = element.getAttribute('data-henge-canonical-id') || element.getAttribute('data-henge-analytics-section') ||
      (tagged && (tagged.getAttribute('data-henge-canonical-id') || tagged.getAttribute('data-henge-analytics-section')));
    if (canonical) return canonical.replace(/[^A-Za-z0-9_-]/g, '_').slice(0, 100);
    var id = element.id || '';
    if (element.querySelector('[data-henge-hero-carousel]') || /henge_hero_carousel/.test(id)) return 'hero';
    if (/henge_flexible_section_wxzhwb/.test(id)) return 'popularity';
    if (/henge_flexible_section_gGyPfT/.test(id)) return 'taste';
    if (/henge_flexible_section_xgdUBk/.test(id)) return 'achievement';
    if (/advanced_content_ULbtmd/.test(id)) return 'expert_voice';
    if (/customer_voice_gallery/.test(id) || element.querySelector('.henge-voices')) return 'customer_voice';
    if (/henge_carousel/.test(id)) return 'production_process';
    if (/advanced_content_ybryLg/.test(id)) return 'product_detail';
    if (/c_faq/.test(id) || element.querySelector('.faq-section-custom')) return 'faq';
    if (/lottery_form/.test(id) || element.querySelector('.clear-lottery-form-section')) return 'form';
    if (/lottery_countdown/.test(id) || element.querySelector('.henge-lottery-countdown')) return 'lottery_countdown';
    if (/lottery_status_box|advanced_content_7ThdU9/.test(id) || element.querySelector('.henge-lottery-status-box-section')) return 'lottery_overview';
    return 'content_' + String(fallbackIndex + 1).padStart(2, '0');
  }

  function assignSectionIds(elements) {
    var counts = {};
    var totals = {};
    elements.forEach(function (element, index) {
      var base = sectionBaseId(element, index);
      totals[base] = (totals[base] || 0) + 1;
    });
    return elements.map(function (element, index) {
      var base = sectionBaseId(element, index);
      counts[base] = (counts[base] || 0) + 1;
      return {
        element: element,
        id: totals[base] > 1 ? base + '_' + counts[base] : base,
        inView: false,
        viewed: false,
        candidateTimer: null,
        activeStartedAt: 0,
        segmentElapsedMs: 0,
        leaveCount: 0
      };
    });
  }

  function startSectionCandidate(state) {
    if (state.candidateTimer || state.activeStartedAt || !isPageActive()) return;
    state.candidateTimer = window.setTimeout(function () {
      state.candidateTimer = null;
      if (!state.inView || !isPageActive()) return;
      state.activeStartedAt = performance.now();
      if (!state.viewed) {
        state.viewed = true;
        track('section_view', { section_id: state.id }, { once: true, onceKey: 'section_view_' + state.id });
      }
    }, SECTION_VIEW_DELAY_MS);
  }

  function pauseSection(state) {
    if (!state.activeStartedAt) return;
    state.segmentElapsedMs += Math.max(0, performance.now() - state.activeStartedAt);
    state.activeStartedAt = 0;
  }

  function leaveSection(state, final) {
    if (state.candidateTimer) {
      window.clearTimeout(state.candidateTimer);
      state.candidateTimer = null;
    }
    pauseSection(state);
    var seconds = Math.round(state.segmentElapsedMs / 100) / 10;
    if (state.viewed && seconds >= SECTION_MIN_SECONDS) {
      state.leaveCount += 1;
      track('section_leave', {
        section_id: state.id,
        section_seconds: seconds,
        event_value: final ? 'page_exit' : 'viewport_exit'
      }, { onceKey: 'section_leave_' + state.id + '_' + state.leaveCount });
    }
    state.segmentElapsedMs = 0;
  }

  function initSectionTracking() {
    if (!('IntersectionObserver' in window)) return;
    var elements = Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section')).filter(isTrackableSectionElement);
    sectionStates = assignSectionIds(elements);
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = sectionStates.find(function (item) { return item.element === entry.target; });
        if (!state) return;
        var sufficientlyVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        state.inView = sufficientlyVisible;
        if (sufficientlyVisible) startSectionCandidate(state);
        else leaveSection(state, false);
      });
    }, { threshold: [0, 0.25, 0.5, 0.75] });

    sectionStates.forEach(function (state) {
      state.element.setAttribute('data-henge-analytics-section', state.id);
      observer.observe(state.element);
    });
  }

  function faqId(trigger) {
    var item = trigger.closest('.faq-item-custom, details, [data-faq-item]');
    var root = trigger.closest('.faq-list-custom, [data-faq-list]') || document;
    var items = Array.prototype.slice.call(root.querySelectorAll('.faq-item-custom, details, [data-faq-item]'));
    var index = item ? items.indexOf(item) : -1;
    if (index < 0) index = Array.prototype.slice.call(document.querySelectorAll('.faq-trigger-custom, details summary')).indexOf(trigger);
    return 'faq_' + String(Math.max(0, index) + 1).padStart(2, '0');
  }

  function initFaqTracking() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('.faq-trigger-custom, details summary');
      if (!trigger) return;
      window.setTimeout(function () {
        var open = trigger.matches('summary')
          ? Boolean(trigger.closest('details') && trigger.closest('details').open)
          : trigger.getAttribute('aria-expanded') === 'true';
        var id = faqId(trigger);
        track(open ? 'faq_open' : 'faq_close', { faq_id: id, event_value: open ? 'open' : 'close' });
      }, 0);
    }, true);
  }

  function isLotteryForm(form) {
    if (!form || !form.matches) return false;
    return Boolean(form.closest('.clear-lottery-form-section') && form.querySelector('input[name="return_to"][value="/pages/thanks"]'));
  }

  function formId(form, index) {
    return String(form.id || ('lottery_form_' + (index + 1))).replace(/[^A-Za-z0-9_-]/g, '_').slice(0, 120);
  }

  function formEventDetails(state, extra) {
    var details = {
      form_id: state.id,
      section_id: state.canonicalId,
      form_placement: state.placement
    };
    Object.keys(extra || {}).forEach(function (key) { details[key] = extra[key]; });
    return details;
  }

  function markApplicationPending(state) {
    var completionId = createId('hc_');
    var pending = {
      timestamp: Date.now(),
      expires_at: Date.now() + APPLICATION_BRIDGE_TTL_MS,
      visitor_id: visitorId,
      session_id: sessionId,
      journey_id: journeyId,
      completion_id: completionId,
      lp_variant: lpVariant,
      form_id: state.id,
      section_id: state.canonicalId,
      form_placement: state.placement
    };
    storageSet('session', KEYS.applicationPending, JSON.stringify(pending));
    storageSet('local', KEYS.applicationBridge, JSON.stringify(pending));
    applicationBridge = pending;
    return pending;
  }

  function initFormTracking() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('.clear-lottery-form-section form')).filter(function (form) {
      return isLotteryForm(form) && isRenderedElement(form);
    });
    formStates = forms.map(function (form, index) {
      var placement = index === 0 ? 'top' : 'bottom';
      var state = {
        form: form,
        id: formId(form, index),
        canonicalId: placement === 'top' ? 'form_1' : 'form_2',
        placement: placement,
        viewed: false,
        started: false,
        viewTimer: null
      };
      form.setAttribute('data-henge-form-id', state.id);
      form.setAttribute('data-henge-form-placement', state.placement);
      form.setAttribute('data-henge-canonical-id', state.canonicalId);

      form.addEventListener('focusin', function (event) {
        if (!event.isTrusted || state.started) return;
        state.started = true;
        track('form_start', formEventDetails(state), { once: true, onceKey: 'form_start_' + state.id });
      }, true);
      form.addEventListener('input', function (event) {
        if (!event.isTrusted || state.started) return;
        state.started = true;
        track('form_start', formEventDetails(state), { once: true, onceKey: 'form_start_' + state.id });
      }, true);
      form.addEventListener('invalid', function () {
        track('form_error', formEventDetails(state, { event_value: 'native_validation' }));
      }, true);
      form.addEventListener('submit', function () {
        if (form.checkValidity && !form.checkValidity()) {
          track('form_error', formEventDetails(state, { event_value: 'invalid_submit' }));
          return;
        }
        var pending = markApplicationPending(state);
        track('form_submit', formEventDetails(state, { completion_id: pending.completion_id }), { once: true, onceKey: 'form_submit_' + state.id, immediate: true });
      }, true);

      return state;
    });

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = formStates.find(function (item) { return item.form === entry.target; });
        if (!state || state.viewed) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
          if (state.viewTimer) return;
          state.viewTimer = window.setTimeout(function () {
            if (!state.viewed) {
              state.viewed = true;
              track('form_view', formEventDetails(state), { once: true, onceKey: 'form_view_' + state.id });
            }
          }, 500);
        } else if (state.viewTimer) {
          window.clearTimeout(state.viewTimer);
          state.viewTimer = null;
        }
      });
    }, { threshold: [0, 0.3, 0.6] });
    formStates.forEach(function (state) { observer.observe(state.form); });
  }

  function persistCompletionEvent(event) {
    if (!event || !event.completion_id) return;
    var pendingEvents = parseJson(storageGet('local', KEYS.completionQueue), []);
    if (!Array.isArray(pendingEvents)) pendingEvents = [];
    pendingEvents = pendingEvents.filter(function (item) { return item.completion_id !== event.completion_id; });
    pendingEvents.push(event);
    storageSet('local', KEYS.completionQueue, JSON.stringify(pendingEvents.slice(-10)));
  }

  function isCompletionDelivered(completionId) {
    if (!completionId) return false;
    var done = parseJson(storageGet('local', KEYS.completionDone), {});
    return Number(done[completionId] || 0) > Date.now();
  }

  function confirmedSuccessOnCurrentPage() {
    if (path === '/pages/thanks') return 'thanks';
    try {
      return new URLSearchParams(window.location.search || '').get('customer_posted') === 'true' ? 'shopify_success' : '';
    } catch (error) {
      return '';
    }
  }

  function trackApplicationComplete() {
    var successSource = confirmedSuccessOnCurrentPage();
    if (!successSource) return;

    var pending = parseJson(storageGet('session', KEYS.applicationPending), null) || readApplicationBridge();
    var legacyPending = parseJson(storageGet('session', 'henge_lottery_application_pending_v1'), null);
    var timestamp = pending && Number(pending.timestamp);
    var isRecentPending = timestamp && Date.now() - timestamp < 2 * 60 * 60 * 1000;
    if (!isRecentPending && !legacyPending) return;
    var completionId = pending && validAnonymousId(pending.completion_id, 'hc_') ? pending.completion_id : createId('hc_');
    if (isCompletionDelivered(completionId) || storageGet('session', KEYS.applicationComplete) === completionId) return;
    var details = {
      event_value: successSource,
      completion_id: completionId,
      form_id: pending && pending.form_id || '',
      section_id: pending && pending.section_id || '',
      form_placement: pending && pending.form_placement || ''
    };

    storageSet('session', KEYS.applicationComplete, completionId);
    storageRemove('session', KEYS.applicationPending);
    if (details.form_id) track('form_success', details, { once: true, onceKey: 'form_success_' + completionId });
    track('application_complete', details, { once: true, onceKey: 'application_complete_' + completionId, immediate: true });
  }

  function pauseVisibleSections() {
    sectionStates.forEach(function (state) { pauseSection(state); });
  }

  function resumeVisibleSections() {
    sectionStates.forEach(function (state) {
      if (state.inView && state.viewed && !state.activeStartedAt) state.activeStartedAt = performance.now();
      else if (state.inView && !state.viewed) startSectionCandidate(state);
    });
  }

  function readSessionTotals() {
    return parseJson(storageGet('session', KEYS.sessionTotals), { active_seconds: 0, total_seconds: 0, max_scroll_depth: 0, pageviews: 0 });
  }

  function finalizeSessionSummary() {
    if (finalSummarySent) return;
    finalSummarySent = true;
    pauseActiveClock();
    sectionStates.forEach(function (state) { if (state.inView) leaveSection(state, true); });

    var totals = readSessionTotals();
    totals.active_seconds = Number(totals.active_seconds || 0) + getActiveSeconds();
    totals.total_seconds = Number(totals.total_seconds || 0) + getTotalSeconds();
    totals.max_scroll_depth = Math.max(Number(totals.max_scroll_depth || 0), maxScrollDepth);
    totals.pageviews = Number(totals.pageviews || 0) + 1;
    storageSet('session', KEYS.sessionTotals, JSON.stringify(totals));

    track('session_summary', {
      event_value: 'session_to_date',
      active_seconds: Math.round(totals.active_seconds * 10) / 10,
      total_seconds: Math.round(totals.total_seconds * 10) / 10,
      scroll_depth: totals.max_scroll_depth
    }, { once: true });
    sendSessionSnapshotV2('pagehide', true, false);
    flushQueue(true);
  }

  function initLifecycleTracking() {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        pauseActiveClock();
        pauseVisibleSections();
        track('page_hidden', { event_value: 'hidden' });
        sendSessionSnapshotV2('visibility_hidden', true, false);
        flushQueue(true);
      } else {
        resumeActiveClock();
        resumeVisibleSections();
      }
    });
    window.addEventListener('pagehide', finalizeSessionSummary, { capture: true });
  }

  function initIdentityActivityTracking() {
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (event.isTrusted) touchJourneyIdentity(false);
      }, { passive: true, capture: true });
    });
  }

  function init() {
    touchJourneyIdentity(true);
    setClarityIdentityTags(0);
    resendPendingSnapshotV2();
    track('page_view', {}, { once: true, immediate: true });
    initLifecycleTracking();
    initIdentityActivityTracking();
    trackApplicationComplete();

    if (path !== '/pages/thanks') {
      initEngagementTracking();
      initScrollTracking();
      initSectionTracking();
      initFaqTracking();
      initFormTracking();
    }

    flushTimer = window.setInterval(function () { flushQueue(false); }, FLUSH_INTERVAL_MS);
    snapshotTimer = window.setInterval(function () {
      sendSessionSnapshotV2('interval', false, false);
    }, SNAPSHOT_INTERVAL_MS);
  }

  window.HENGE_LP_ANALYTICS_TEST = {
    getState: function () {
      return {
        enabled: true,
        endpointConfigured: Boolean(endpoint),
        visitorIdPrefixValid: visitorId.indexOf('hv_') === 0,
        sessionIdPrefixValid: sessionId.indexOf('hs_') === 0,
        journeyIdPrefixValid: journeyId.indexOf('hj_') === 0,
        journeyId: journeyId,
        pageviewIdPrefixValid: pageviewId.indexOf('hp_') === 0,
        queuedEvents: queue.map(function (event) { return event.event_name; }),
        maxScrollDepth: maxScrollDepth,
        activeSeconds: getActiveSeconds(),
        sectionIds: sectionStates.map(function (state) { return state.id; }),
        sessionRevision: sessionState.revision,
        snapshotSequence: sessionState.sequence,
        sessionEventCount: sessionState.events.length,
        snapshotSendCount: sessionState.snapshot_send_count,
        lastPayloadSizeBytes: sessionState.last_payload_size_bytes,
        averagePayloadSizeBytes: sessionState.average_payload_size_bytes,
        pendingSnapshot: Boolean(storageGet('session', KEYS.pendingSnapshotV2))
      };
    },
    flush: function () { flushQueue(false); },
    snapshot: function () { return sendSessionSnapshotV2('manual_test', false, false); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
